<mat-dialog-content>
  <lemon-dialog-header> Käyttäjän vahvan tunnistautumisen historia </lemon-dialog-header>

  <table style="padding-left: 3em; padding-right: 3em; border-spacing: 10px">
    @for (log of data; track log) {
      <tr>
        <td>{{ log.logTime | ltimestamptimel: 'fi' }}</td>
        <td style="font-weight: bold">{{ log.step }}</td>
        <td style="font-size: 12px">{{ log.details }}</td>
        <td>{{ log.env }}</td>
      </tr>
    }
  </table>
</mat-dialog-content>
<mat-dialog-actions style="padding-left: 3em; padding-right: 3em">
  <app-primary-button (click)="sulje()" actionId="Sulje (käyttäjän vahvan tunnistautumisen historia dialog)">Sulje</app-primary-button>
</mat-dialog-actions>
